/* eslint-disable no-unused-vars */
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import {
  cannotAccessList,
  defaultPage
} from '@/assets/cannotAccessList';
import TokenMixin from '@/mixins/TokenMixin'
import Validator from '@/prototype/Validator'
import Error from '@/views/Error.vue';
import i18n from '@/i18n';

Vue.use(VueRouter);
Vue.mixin(TokenMixin)
Vue.use(Validator)
const vm = new Vue({ i18n });

const routes = [
  {
    path: '/',
    redirect: 'login',
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/pages/Login.vue'),
    meta: {
      layout: 'blank',
      title: vm.$t('login'),
      skipAuth: true,
    },
  },
  {
    path: '/user',
    name: 'UserList',
    component: () => import('@/views/pages/admin/user/UserList.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.user'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['UserList'],
    },
  },
  {
    path: '/user/create',
    name: 'CreateUser',
    component: () => import('@/views/pages/admin/user/CreateUser.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.createUser'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['CreateUser'],
    },
  },
  {
    path: '/user/detail/:id',
    name: 'UserDetail',
    component: () => import('@/views/pages/admin/user/UserDetail.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.userDetail'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['UserDetail'],
    },
  },
  {
    path: '/user/company/:id',
    name: 'CompanyDetail',
    component: () => import('@/views/pages/admin/user/CompanyDetail.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.companyDetail'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['CompanyDetail'],
    },
  },
  {
    path: '/user/company/create/:uid',
    name: 'CreateCompany',
    component: () => import('@/views/pages/admin/user/CompanyDetail.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.addCompany'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['CreateCompany'],
    },
  },
  {
    path: '/order',
    name: 'OrderList',
    component: () => import('@/views/pages/admin/order/OrderList.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.order'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['OrderList'],
    },
  },
  {
    path: '/user/company/order/:cid',
    name: 'CompanyOrderList',
    component: () => import('@/views/pages/admin/order/OrderList.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.order'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['OrderList'],
    },
  },
  {
    path: '/order/detail/:id',
    name: 'OrderDetail',
    component: () => import('@/views/pages/admin/order/OrderDetail.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.orderDetail'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['OrderDetail'],
    },
  },
  {
    path: '/order/invoice/create',
    name: 'CreateInvoice',
    component: () => import('@/views/pages/admin/order/InvoiceDetail.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.createInvoice'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['CreateInvoice'],
    },
  },
  {
    path: '/order/invoice/:id',
    name: 'InvoiceDetail',
    component: () => import('@/views/pages/admin/order/InvoiceDetail.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.orderDetail'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['InvoiceDetail'],
    },
  },
  {
    path: '/applied-service',
    name: 'AppliedServiceList',
    component: () => import('@/views/pages/admin/AppliedServiceList.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.customerNewService'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['AppliedServiceList'],
    },
  },
  {
    path: '/letter-package',
    name: 'LetterPackageList',
    component: () => import('@/views/pages/admin/letter/LetterPackageList.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.letterAndPackage'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['LetterPackageList'],
    },
  },
  {
    path: '/letter-package/create',
    name: 'CreateLetterPackage',
    component: () => import('@/views/pages/admin/letter/LetterPackageDetail.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.createLetterPackage'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['LetterPackageDetail'],
    },
  },
  {
    path: '/letter-package/detail/:id',
    name: 'LetterPackageDetail',
    component: () => import('@/views/pages/admin/letter/LetterPackageDetail.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.letterPackageDetail'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['LetterPackageDetail'],
    },
  },
  {
    path: '/blog',
    name: 'BlogList',
    component: () => import('@/views/pages/admin/blog/BlogList.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.blog'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['BlogList'],
    },
  },
  {
    path: '/blog/create',
    name: 'CreateBlog',
    component: () => import('@/views/pages/admin/blog/BlogDetail.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.addBlog'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['BlogDetail'],
    },
  },
  {
    path: '/blog/detail/:id',
    name: 'BlogDetail',
    component: () => import('@/views/pages/admin/blog/BlogDetail.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.blogDetail'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['BlogDetail'],
    },
  },
  {
    path: '/faq',
    name: 'FaqList',
    component: () => import('@/views/pages/admin/faq/FaqList.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.faq'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['FaqList'],
    },
  },
  {
    path: '/faq/create',
    name: 'CreateFaq',
    component: () => import('@/views/pages/admin/faq/FaqDetail.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.addFaq'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['FaqDetail'],
    },
  },
  {
    path: '/faq/detail/:id',
    name: 'FaqDetail',
    component: () => import('@/views/pages/admin/faq/FaqDetail.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.faqDetail'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['FaqDetail'],
    },
  },
  {
    path: '/enquiry',
    name: 'EnquiryList',
    component: () => import('@/views/pages/admin/enquiry/EnquiryList.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.enquiry'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['EnquiryList'],
    },
  },
  {
    path: '/setting',
    name: 'Setting',
    component: () => import('@/views/pages/admin/Setting.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.setting'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['Setting'],
    },
  },

  // --------- developer only ---------
  {
    path: '/plan',
    name: 'PlanList',
    component: () => import('@/views/pages/developer/plan/PlanList.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.plan'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['PlanList'],
    },
  },
  {
    path: '/plan/create',
    name: 'CreatePlan',
    component: () => import('@/views/pages/developer/plan/PlanDetail.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.addPlan'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['PlanDetail'],
    },
  },
  {
    path: '/plan/detail/:id',
    name: 'PlanDetail',
    component: () => import('@/views/pages/developer/plan/PlanDetail.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.planDetail'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['PlanDetail'],
    },
  },
  {
    path: '/addon',
    name: 'AddonList',
    component: () => import('@/views/pages/developer/addon/AddonList.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.addon'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['AddonList'],
    },
  },
  {
    path: '/addon/create',
    name: 'CreateAddon',
    component: () => import('@/views/pages/developer/addon/AddonDetail.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.addAddon'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['AddonDetail'],
    },
  },
  {
    path: '/addon/detail/:id',
    name: 'AddonDetail',
    component: () => import('@/views/pages/developer/addon/AddonDetail.vue'),
    meta: {
      layout: 'content',
      title: vm.$t('menu.addonDetail'),
      requireAuth: true,
      showTitleAtSlot: true,
      cannotAccess: cannotAccessList['AddonDetail'],
    },
  },
  {
    path: '*',
    name: 'Error',
    component: Error,
    meta: { title: 'Error' },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach(async (to, from, next) => {
  store.dispatch('setLoading', false);
  window.scrollTo(0, 0);

  if (to.meta.requireAuth) {
    const isUserLogin = vm.isUserLogin();

    if (isUserLogin) {
      next();
    } else {
      next('/login');
    }
  } else if (to.meta.skipAuth) {
    const isUserLogin = vm.isUserLogin();
    if (isUserLogin && to.name === 'Login') {
      const userType = vm.getUserType();
      next(defaultPage[userType]);
    } else {
      next();
    }
  } else {
    next();
  }
})

const DEFAULT_TITLE = 'Corp Plus CMS';
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = (`${to.meta.title} - ` || '') + DEFAULT_TITLE
  })
})

export default router
